import React from "react";

export function retailerTitle(retailer) {
  return retailer
    ?.split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function giftCardTypeLabel(types) {
  if (!types?.length) return "";
  return types.length === 1
    ? types[0].replace(/_/g, " ")
    : types.join(" & ").replace(/_/g, " ");
}

const PILL_TONES = {
  success: { color: "#4caf50", bg: "rgba(76,175,80,0.16)" },
  danger: { color: "#f27059", bg: "rgba(242,112,89,0.16)" },
  neutral: { color: "#e8b84b", bg: "rgba(232,184,75,0.16)" },
  primary: { color: "#00ADB5", bg: "rgba(0,173,181,0.16)" },
};

export default function GiftCardTile({
  logo,
  bg,
  retailerName,
  typeText,
  priceText,
  secondaryText,
  pillText,
  pillTone = "neutral",
  action,
  onClick,
}) {
  const pillColors = PILL_TONES[pillTone] || PILL_TONES.neutral;

  return (
    <div
      onClick={onClick}
      style={{
        borderRadius: 16,
        border: "1px solid rgba(255,255,255,0.07)",
        overflow: "hidden",
        cursor: onClick ? "pointer" : "default",
        background: "linear-gradient(180deg, rgba(255,255,255,0.02), transparent)",
        boxShadow: "0 16px 34px -26px rgba(0,0,0,0.7)",
        transition: "transform 0.15s, border-color 0.15s",
        display: "flex",
        flexDirection: "column",
      }}
      onMouseEnter={(e) => {
        if (!onClick) return;
        e.currentTarget.style.borderColor = "rgba(255,255,255,0.2)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div
        style={{
          position: "relative",
          height: 148,
          background: bg
            ? `linear-gradient(160deg, ${bg}dd, ${bg}55 70%, transparent)`
            : "linear-gradient(160deg, #2a2a2e, #141416)",
          backgroundColor: bg || "#1a1a1a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        {pillText && (
          <div
            style={{
              position: "absolute",
              top: 10,
              left: "50%",
              transform: "translateX(-50%)",
              padding: "3px 12px",
              borderRadius: 999,
              fontSize: 10,
              fontWeight: 800,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              color: pillColors.color,
              background: pillColors.bg,
              whiteSpace: "nowrap",
            }}
          >
            {pillText}
          </div>
        )}
        {action && <div style={{ position: "absolute", top: 10, right: 10, zIndex: 1 }}>{action}</div>}
        <img
          src={logo}
          alt={retailerName}
          style={{ maxWidth: 108, maxHeight: 40, objectFit: "contain" }}
        />
      </div>
      <div style={{ padding: "14px 16px 16px" }}>
        {typeText && (
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "#c3c8cc",
              marginBottom: 4,
            }}
          >
            {typeText}
          </div>
        )}
        <div
          style={{
            fontSize: 15.5,
            fontWeight: 700,
            color: "#fff",
            marginBottom: 8,
            overflowWrap: "anywhere",
          }}
        >
          {retailerName}
        </div>
        <div
          style={{
            fontFamily: "ui-monospace, SF Mono, Menlo, Fira Code, monospace",
            fontSize: 17,
            fontWeight: 700,
            color: "#00ADB5",
          }}
        >
          {priceText}
        </div>
        {secondaryText && <div style={{ fontSize: 11.5, color: "#8b9296", marginTop: 5 }}>{secondaryText}</div>}
      </div>
    </div>
  );
}
